<template>
  <div class="surplus-return-part-added srpa">
    <div class="container-fluid">
      <br>
      <p>
        Returnable parts must have been invoiced within the past 3 years to be eligible for Surplus Return.
      </p>
      <br>

      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-6">
            <div class="row modify">
              <div class="col-sm-3">
                <label>
                  Search
                  <br>For Parts:
                </label>
              </div>
              <div class="col-sm-4">
                <input
                  id="txtOemPartCode"
                  v-model="returnDraftItemDto.OemPartCode"
                  class="first form-control addPartInput"
                  type="text"
                  name="qo-partnum"
                  placeholder="Enter Part #"
                  tabindex="3"
                  maxlength="25"
                  @input="function(){returnDraftItemDto.OemPartCode = returnDraftItemDto.OemPartCode.toUpperCase().trim()}"
                >
              </div>
              <div class="col-sm-2">
                <input
                  id="txtQuantity"
                  v-model="returnDraftItemDto.Quantity"
                  class="first form-control"
                  name="txtQuantity"
                  tabindex="4"
                  placeholder="Qty"
                >
              </div>
              <div class="col-sm-3">
                <DnFunctionButton
                  button-id="addPartToListBtn"
                  :callback-fn="AddDraftItem"
                  text="Add"
                  extra-classes="addPartToListBtn"
                  :size="largeSize"
                  :loading="draftLoading"
                />
              </div>
            </div>
          </div>
          <div id="surplus-upload-parts-wrapper" class="col-sm-6">
            <file-upload
              v-show="!isLoadingFile"
              ref="fileUpload"
              drop-zone-label="Upload Parts CSV"
              upload-button-label="Browse"
              :accepted-file-types="GetCSVFileInputType"
              :show-tooltip="true"
              description="Upload Parts CSV"
              :show-description="BrowserIsIE()"
              :show-drag-and-drop="!BrowserIsIE()"
              tooltip-title="CSV Content"
              :tooltip-text="fileUploadTooltipText"
              @submit-file="SubmitFile"
            />
            <!-- FILE LOADING AND ADDING DIALOG -->
            <div v-show="isLoadingFile" class="srpa__file-upload-dialog">
              <!-- VALIDATING FILE UPLOAD -->
              <div v-if="isValidatingFile">
                <div
                  v-if="fileBatch.PercentageComplete === 0"
                  class="row no-gutters"
                >
                  <strong>Validation Starting...</strong>&nbsp;<i class="element-loading srpa__file-upload-spinner" />          
                </div>
                <b-progress
                  v-else
                >
                  <b-progress-bar
                    :value="fileBatch.PercentageComplete"
                    show-progress
                    animated
                  >
                    {{ fileBatch.PercentageComplete }}%
                  </b-progress-bar>
                </b-progress>
              </div>
              <!-- ADDING PARTS FROM FILE UPLOAD -->
              <div v-if="isAddingParts" class="row no-gutters">
                <strong>Adding parts to your return...</strong>&nbsp;<i class="element-loading srpa__file-upload-spinner" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <br>
      <div class="container-fluid">
        <div class="row">
        <DnTable
          id="partsToReturnTbl"
          hover
          striped
          :items="returnDraftDto.Items"
          :fields="partsToReturnColumns"
          stacked="md"
          :no-provider-filtering="true"
          show-empty
          empty-text="No items have been added to this return"
          :no-local-sorting="true"
          class="blue mb-0"
        >
          <template #PartDescription="{ row }">
            <div>{{ row.item.PartDescription }}</div>
            <div v-for="(error,key) in row.item.Errors" :key="key" class="alert alert-danger">
              <div v-if="error !== 'LineItemMinimumAmount'">
                {{ getReturnErrorContent(error) }}
              </div>
              <div v-if="error === 'LineItemMinimumAmount'"> 
                {{ GetLineItemMinimumAmountErrorMessage(error) }}
              </div>
            </div>
          </template>
          <template #Price="{ row }">
            <CurrencyText :currency-code="row.item.Currency" :amount="row.item.Price" />
          </template>
          <template #Total="{ row }">
            <CurrencyText :currency-code="row.item.Currency" :amount="row.item.Total" />
          </template>
          <template #DeleteRow="{ row }">
            <button 
              :id="'btnDeleteRow_'+row.item.Id" 
              type="button" 
              class="btn btn-small"
              @click="DeleteFromReturn($event, row.item.Id, row.index)"
            >
              <i class="icon-trash" />
            </button>
          </template>
        </DnTable>
          <div class="row container-fluid no-gutters subTotalRow srpa__totals-section">
            <div class="col px-1 row no-gutters">
              <div class="col-3">
                <strong>Promatch Parts Return Total</strong>
              </div>
              <div class="col-9">
                <div class="row">
                  <div class="col-8">
                    <div class="pull-right">
                      <strong>
                        <label class="subTotalAvailableLbl">Available Amount:</label>
                        &nbsp;&nbsp;
                        <CurrencyText
                          :amount="returnDraftDto.RpReturnAmountRemaining"
                          class="subTotalAvailableAmt"
                        />
                      </strong>
                    </div>
                  </div>
                  <div class="col-4">
                    <strong>
                      <CurrencyText
                        :amount="returnDraftDto.SubtotalRapidparts"
                        class="pull-right"
                      />
                    </strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row container-fluid no-gutters subTotalRow">
            <div class="col px-1 row no-gutters">
              <div class="col-3">
                <strong>OEM Parts Return Total</strong>
              </div>
              <div class="col-9">
                <div class="row">
                  <div class="col-8">
                    <div class="pull-right">
                      <strong>
                        <label class="subTotalAvailableLbl">Available Amount:</label>
                        &nbsp;&nbsp;
                        <CurrencyText
                          :amount="returnDraftDto.McfReturnAmountRemaining"
                          class="subTotalAvailableAmt"
                        />
                      </strong>
                    </div>
                  </div>
                  <div class="col-4">
                    <strong>
                      <CurrencyText :amount="returnDraftDto.SubtotalMcf" class="pull-right" />
                    </strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row container-fluid no-gutters modify px-2 mb-5">
            <div class="col px-1 pt-1 row no-gutters">
              <div class="col-3">
                <strong>TOTAL</strong>
              </div>
              <div class="col-9">
                <div class="row">
                  <div class="col-8">
                    <div class="pull-right">
                      <strong>
                        <label class="">Available Amount:</label>
                        &nbsp;&nbsp;
                        <CurrencyText
                          :amount="availableTotal"
                          class=""
                        />
                      </strong>
                    </div>
                  </div>
                  <div class="col-4">
                    <strong>
                      <CurrencyText :amount="total" class="pull-right" />
                    </strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { constants } from "@/const"
  import DnFunctionButton from "@/components/Elements/DnFunctionButton"
  import FileUpload from "@/components/Elements/FileUpload"
  import CurrencyText from "@/components/Elements/CurrencyText"
  import { sizeHelper } from "@/components/mixins/sizeHelper"
  import { returnAddItems } from "@/components/ReverseLogistics/Returns/mixins/AddItems"
  import { ReturnsService } from "@/services/ReturnsService"
  import { mapGetters } from "vuex"
  import BootstrapVue from "bootstrap-vue"
  import { ErrorLogService } from "@/services/ErrorLogService"
  import { stringHelper } from "@/components/mixins/stringHelper"
  import DnTable from "@/components/Elements/DnTable/DnTable.vue";

  export default {
    components: {
      CurrencyText,
      DnFunctionButton,
      FileUpload,
      DnTable
    },
    mixins: [sizeHelper, returnAddItems, stringHelper],
    props: {
      returnDraftDto: {
        type: Object,
        default: () => ({})
      }
    },
    data: () => ({
      fileBatch: {
        BlobId: "",
        CurrentBatchContent: [],
        BatchSize: "",
        CurrentBatchNumber: "",
        TotalBatchCount: "",
        PercentageComplete: 0,
        BatchErrors: {},
        constants:  Object
      },
      errorsCsv: "",
      fileUploadTooltipText: "Your CSV should contain two columns. In the first column, list your part numbers. In your second column, list your quantities. Do not add headers to your columns.",
      isLoadingFile: false,
      isValidatingFile: false,
      isAddingParts: false
    }),
    computed: {
      ...mapGetters(["user", "activeAccountId", "errorList", "getContentItem"]),
      GetCSVFileInputType(){
        return constants.INPUT_FILE_TYPES.CSV;
      },
    },
    mounted () {
      this.errorsCsv = "";
      // make sure we have totals and items
      ReturnsService.GetDraftReturn(this.activeAccountId, this.user.UserId, this.returnDraftDto.Id).then(draftDto => {
        this.updateDto(draftDto.data)
        this.calculateTotals()
      })
    },
    methods: {
      GetLineItemMinimumAmountErrorMessage: function (error) {
        let amount = this.returnDraftDto.MinimumItemAmount;
        let currencyAmount = this.formatToCurrency(amount, this.returnDraftDto.Items[0].Currency);
        return this.format(this.getContentItem(error), currencyAmount);
      },      
      SubmitFile: function (file) {  
        let self = this
        this.file = file
        this.fileBatch.PercentageComplete = 0
        this.isLoadingFile = true;
        this.isValidatingFile = true;
        ReturnsService.UploadReturnPartsFile(this.activeAccountId, this.user.UserId, this.file).then(partsFile => {
          self.fileBatch.BlobId = partsFile.data.Filename
          self.fileBatch.CurrentBatchNumber = 1
          self.ProcessBatch(self.fileBatch)
        })
      },
      ProcessBatch: function (fileBatch) {
        // A recursive function which continues until all batches are processed.
        let self = this
        this.fileBatch = fileBatch
        ReturnsService.ProcessFileBatch(this.activeAccountId, this.user.UserId, this.returnDraftDto.Id, this.fileBatch).then(resultBatch => {
          self.fileBatch = resultBatch.data
          if( resultBatch.data.BatchErrors !== undefined){
            let batchErrors = resultBatch.data.BatchErrors 
            Object.keys(batchErrors).forEach( function(key){ 
              self.errorsCsv += key + "," + self.getReturnErrorContent(batchErrors[key]) + "\r\n"
            })
          }
                   
          self.fileBatch.CurrentBatchNumber += 1

          if (self.fileBatch.CurrentBatchNumber <= self.fileBatch.TotalBatchCount) {
            self.ProcessBatch(self.fileBatch)
          } else {
            self.isValidatingFile = false;
            self.FinishUpload()
          }
        })
          .catch( error => {
            self.isValidatingFile = false;
            self.isLoadingFile = false;
            self.isAddingParts = false;
            ErrorLogService.LogException(error);
            this.$store.commit("pushMessage", {
              header: "There was an error during file validation.",
              IsError: true
            })
          });
      },
      FinishUpload: function(){
        let self = this;
        this.isAddingParts = true;

        ReturnsService.GetDraftReturn(self.activeAccountId, self.user.UserId, self.returnDraftDto.Id).then(draftDto => {
          self.updateDto(draftDto.data)
          self.calculateTotals()
          self.$refs.fileUpload.ClearFileContents()
          
          if( Object.keys(self.errorsCsv).length > 0){
            self.$refs.fileUpload.ShowFileUploadErrors(self.errorsCsv);
          }
        }).finally(results => {
          self.isAddingParts = false;
          self.isLoadingFile = false;
        })
      },
      BrowserIsIE(){
        return IsIE();
      }
    }
  }
</script>

<style lang="scss">
#surplus-upload-parts-wrapper{
  
  #drop-zone{
    width: 70%;
    float: left;

    .images-uploaded-text{
      bottom: 110px;
      white-space: nowrap;
      *{
          display: inline-block;
          height: 0;
          font-size: 12px;
      }
    }
  }
  
  #fileUploadBrowseButton, #fileUploadSubmitButton{
    width: 25%;
    margin: 2px 0;
  }

  #ToolTipPopOver{
    position: absolute;
    top: 4px;
    right: 8px;
  }
}

.srpa__file-upload-dialog {
  color: #205cb7;
  white-space: nowrap;
  overflow: hidden;
  padding: 0.5em;
  background-color: #e0ffff;
  border: 2px solid #205cb7;
  border-radius: 5px;
  height: 100%;
}

.srpa__file-upload-spinner {
  padding: 0;
}

.srpa__totals-section{
  margin-top: 1rem !important;
}
</style>
